/* File: permissionsContext.js
 * Path: ananunadm/src/helpers/permissionsContext.js
*/
import { useContext, createContext } from "react";

export const PermissionContext = createContext();

export function usePermissions() {
	return useContext(PermissionContext);
}
